<template>
  <div>
    <div v-if="show" class="timparty-basic-modal basic-modal modal fade show" :id="modalId" tabindex="-1" role="dialog"
         :aria-labelledby="modalId" aria-hidden="true">
      <div :class="'modal-dialog ' + ( modalClass ? modalClass : '' )" role="document">
        <div class="modal-content overflow-auto" :style="computedModalStyle">
            <span class=" btn-modal-close">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="closeButton"
                      @click.prevent="CloseModal">
                <span aria-hidden="true"><img :src="themePath('images/close-modal.png')" class="btn-icon-modal"></span>
              </button>
            </span>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/* eslint-disable */

import TimPartyMixin from "@/mixins/TimPartyMixin";
import $             from 'jquery';

export default {
  name: 'BasicModal',
  mixins: [TimPartyMixin],

  props: {
    modalId: {
      type: String,
      required: true
    },
    modalClass: {
      type: String,
      required: false
    },
    modalStyle: {
      type: String,
      required: false
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    show: {
      type: Boolean,
      default: null
    },
    contestId: {
      type: Number,
      required: false
    }

  },
  data: function () {
    return {};
  },
  created: function () {
    /*
    if( this.show === true || this.show === false ){
      this.HandleModalToggle(this.show);
    }
    */

  },
  computed: {
    computedModalStyle() {
      return this.parseStyle(this.modalStyle);
    }
  },

  methods: {
    CloseModal: function () {
      if (this.contestId) {
        $('#modal-acceptance-' + this.contestId).appendTo('#instant-win-card-' + this.contestId);
      }
      this.$emit('modalClose');
    },

    HandleModalToggle: function (show) {
      this.$forceUpdate();
      if (show) {
        $('body').addClass('modal-open');
      }
      else {
        $('body').removeClass('modal-open');
      }
    },

    parseStyle(styleString) {
      if (!styleString) return {};

      // Usa una regex per trovare tutte le coppie chiave:valore, gestendo gli URL
      const regex = /([\w-]+)\s*:\s*([^;]+(?:https?:\/\/[^;]*)?)/g;
      const styleObject = {};
      let match;

      while ((match = regex.exec(styleString)) !== null) {
        const key = match[1].trim();
        const value = match[2].trim();
        styleObject[key] = value;
      }

      return styleObject;
    }

  },

  watch: {
    show: function (new_val, old_val) {
      this.HandleModalToggle(new_val);
    },
    modalStyle: function (new_val, old_val) {
      console.log('Modal style updated:', new_val);
    }
  }
}
</script>


